<template>
  <div class="page">
    <div class="centered-box locations-white locations-generic">
      <div class="row">
        <div class="col">
          <!-- <div class="locations-title">OPENING SOON</div> -->
            <div class="home-text">
              <!-- <em>Opening <strong>Friday, April 19</strong></em> -->
              
              <strong>Saturday, April 18</strong>
              <br /><br />
We will open for boat rental--weather and water conditions permitting—at our <strong>Busse
Reservoir</strong> and <strong>Lake Tampier</strong> locations (weekends only for now) beginning <strong>Saturday, April 18</strong>. Our Skokie Lagoons and Clark Park Chicago locations will open <strong>Saturday, April 25</strong>. We will expand our operating hours to seven days per week across all four sites from Memorial Day.
              <br /><br />
              We are currently taking reservations for the <strong>Des Plaines River Canoe and Kayak
Marathon</strong>. Race day is <strong>Sunday, May 17</strong>. See our Events tab for details. 
              <br />



            <!-- <div class="text-center">And, WE'RE HIRING. For more information, see our Events/Employment tab.       -->
            <!-- <br /><br /> -->
            <!-- <i>Special Note: Our Maple Lake boathouse will remain closed until May 2024</i> -->
            <!-- <br /><br /> 
            <a class="btn-primary btn" href="#/contact">      
            <strong>Contact</strong>
            </a> -->
            </div>
            </div>
          </div>
        </div>
      </div>
  <!-- 
  <div class="page"></div>-->
</template>

<script>
export default {
  name: "Home",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.red {
  color: red;
}

.col {
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.home-text {
  text-align: center;
}

.page {
  background-image: url("../assets/pic4.jpg");
  flex-direction: column;
}
a.btn:hover {
  color: rgb(192, 80, 77) !important;
}
ul {
  list-style-type: none;
}
a.btn-primary {
  margin-top: -35px;
  margin-bottom: 2px;
  text-align: center;
  display: inline-block;
  display: block;
}
i {
  text-align: center;
  display: block;
}
</style>
